<template>
  <div v-if="!profile.isAuthenticated && networks.length">
    <hp5-heading id="search-a-network" tag-selection="h1" size-selection="xl"
      >Search a network</hp5-heading>
    <hp5-spacing-vertical xs="xs" sm="xs" md="xs" lg="xs" />
    <hp5-semantic size-selection="sm">
      <p>
        Choose a network to search, or
        <a
          data-analytics="login-1"
          href="/public/login/?referrer=%2Ffcp%2Fcsearch"
          >sign in</a>
        to search your specific plan’s network.
      </p>
      <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
      <hp5-container columns-sm="4">
        <BaseFCPSelect
          elementId="select-network"
          :items="networkOptions"
          label="Network"
          v-model="criteriaContext.networkId"
        />
      </hp5-container>
    </hp5-semantic>
  </div>
</template>

<script setup>
const { profile, criteriaContext, networks } = useFCPModel()

const networkId = computed(() => criteriaContext.value.networkId)
watch(networkId, () => {
  const theNetwork = networks.value.find(
    (network) => network.networkId == networkId.value
  )
  criteriaContext.value.safelink = theNetwork.safelink
  criteriaContext.value.networkName = theNetwork.networkName
})

const networkOptions = computed(() => networks.value
  .map((network) => {
    return { label: network.networkName, value: network.networkId }
  })
  .sort((a, b) => {
    if (a.label > b.label) {
      return 1
    }
    if (a.label < b.label) {
      return -1
    }
    return 0
  })
)
</script>